import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 text-xs text-neutral-400">
          <span>© 2025 Remindora</span>
          <span className="hidden sm:inline">•</span>
          <Link 
            to="/kvkk" 
            className="hover:text-neutral-600 transition-colors underline-offset-2 hover:underline"
          >
            KVKK
          </Link>
          <span className="hidden sm:inline">•</span>
          <Link 
            to="/geribildirim" 
            className="hover:text-neutral-600 transition-colors underline-offset-2 hover:underline"
          >
            Geribildirim
          </Link>
          <span className="hidden sm:inline">•</span>
          <a 
            href="mailto:bilgilendirme@remindora.io" 
            className="hover:text-neutral-600 transition-colors"
          >
            bilgilendirme@remindora.io
          </a>
        </div>
      </div>
    </footer>
  );
}
